import React, { Component } from 'react'
import { Row, Col, Input, Modal, Select, DatePicker, TimePicker  } from 'antd';
import $ from 'jquery';
import moment from 'moment';
import { getCookie } from '../../../hook';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class NewMeetings extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible: false,
            user_id: '',
            date: 'none',
            time_out: 'none',
            time_in: 'none',
            agency: 'none',
            purpose_of_visit: 'none',
            meeting_outcome: 'none'
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );

    }

    componentWillReceiveProps( nextProps ){

        // Clear Input
        $('input').val( '' );

        
        if( this.refs.date ){
            this.refs.date.value = ''

        }

        this.setState({
            visible: nextProps.onModel
        });

    }

    handleOk = (e) => {

        if( this.state.date === "" || this.state.date === "none" ){
            this.setState({ date: '' });
            return false;
        }

        if( this.state.time_out === "" || this.state.time_out === "none" ){
            this.setState({ time_out: '' });
            return false;
        }

        if( this.state.time_in === "" || this.state.time_in === "none" ){
            this.setState({ time_in: '' });
            return false;
        }

        if( this.state.agency === "" || this.state.agency === "none" ){
            this.setState({ agency: '' });
            return false;
        }

        if( this.state.purpose_of_visit === "" || this.state.purpose_of_visit === "none" ){
            this.setState({ purpose_of_visit: '' });
            return false;
        }

        this.setState({ visible: false });
        this.props.onSubmit( this.state );

    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    componentWillMount(){
        let user = getCookie('dv_hrms_user').split(',');
        this.setState({ user_id: user[1] });
    }

    render() {
        return (
            <Modal
                title="Schedule Meeting"
                maskClosable={ false }
                visible={ this.state.visible }
                onOk={ this.handleOk }
                onCancel={ this.handleCancel }>

                <Row gutter={16} className="mrg_b_10">
                    <Col span={ 8 }>
                        <label className={ ( this.state.date === '') ? 'error': '' }>Date</label>
                        <DatePicker
                            className={ ( this.state.date === '') ? 'br_error': '' }
                            onChange={ ( date, dateString ) => this.setState({ date: dateString }) }
                            style={{ width: '100%' }}  />
                    </Col>
                    <Col span={ 8 }>
                        <label className={ ( this.state.time_out === '') ? 'error': '' }>Start of Meeting</label>
                        <TimePicker
                            className={ ( this.state.time_out === '') ? 'br_error': '' }
                            onChange={ ( time, timeString ) => this.setState({ time_out: timeString }) }
                            style={{ width: '100%' }} use12Hours format="h:mm a" defaultOpenValue={moment('00:00', 'HH:mm')} />
                    </Col>
                    <Col span={ 8 }>
                        <label className={ ( this.state.time_out === '') ? 'error': '' }>End of Meeting</label>
                        <TimePicker 
                            className={ ( this.state.time_out === '') ? 'br_error': '' }
                            onChange={ ( time, timeString ) => this.setState({ time_in: timeString }) }
                            style={{ width: '100%' }} use12Hours format="h:mm a" defaultOpenValue={moment('00:00', 'HH:mm')} />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className={ ( this.state.agency === '') ? 'error': '' }>Client / Agency</label>
                        <Input 
                            className={ ( this.state.agency === '') ? 'br_error': '' }
                            onChange={ (e) => this.setState({ agency: e.target.value }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className={ ( this.state.purpose_of_visit === '') ? 'error': '' }>Purpose of Visit</label>
                        <TextArea 
                            className={ ( this.state.purpose_of_visit === '') ? 'br_error': '' }
                            onChange={ (e) => this.setState({ purpose_of_visit: e.target.value }) } rows={3} />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className={ ( this.state.meeting_outcome === '') ? 'error': '' }>Meeting Outcome</label>
                        <TextArea 
                            value={ this.state.meeting_outcome }
                            className={ ( this.state.meeting_outcome === '') ? 'br_error': '' }
                            onChange={ (e) => this.setState({ meeting_outcome: e.target.value }) } rows={3} />
                    </Col>
                </Row>

            </Modal>
        )
    }
}

export default NewMeetings


// WEBPACK FOOTER //
// ./src/pages/meetings/childs/new.meetings.js